<template>
<main-content>
    <kt-panel>
        <kt-panel-header>
            <kt-panel-header-toolbar>
                <ul class="nav nav-pills" role="tablist">
                    <li class="nav-item">
                        <a class="nav-link active" data-toggle="tab" href="#percent" aria-selected="false">
                            {{ $t('marketing.marketing_setting.marketing_percent') }}
                        </a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" data-toggle="tab" href="#tool_setting" aria-selected="false">
                            {{ $t('marketing.marketing_setting.tool') }}
                        </a>
                    </li>
                </ul>
            </kt-panel-header-toolbar>
        </kt-panel-header>
        <kt-panel-body>
            <div class="tab-content">
                <div class="tab-pane active" id="percent">
                    <marketing-percent-setting v-if="status == 'success'" :marketing_setting="marketing_setting"></marketing-percent-setting>
                </div>
                <div class="tab-pane" id="tool_setting" v-if="status == 'success'">
                    <tool-setting :submit="submit" :marketing_setting="marketing_setting"></tool-setting>
                </div>
            </div>
        </kt-panel-body>
    </kt-panel>
</main-content>
</template>

<script>
import mainContent from '@/components/main-content'
import $ from 'jquery'
import { mapGetters } from "vuex"
import { KTApp } from '@/plugins/core/app'
import { KTUtil } from '@/plugins/core/util'
import toolSetting from "./components/tool-setting"
import marketingPercent from "./components/marketing-percent-setting"
import {marketingService} from "../../common/api.service";

export default {
    name: 'MarketingSetting',
    components: {
        'main-content': mainContent,
        'tool-setting': toolSetting,
        'marketing-percent-setting': marketingPercent
    },
    computed: {
        ...mapGetters('marketing', [
            'marketing_setting' , 'status',
        ])
    },
    data() {
        return {
            active_pane: '#tool_setting',
        }
    },
    mounted() {
        this.$store.dispatch('marketing/fetchSetting')

        $('a[data-toggle="tab"]').on('show.bs.tab', (e) => {
            this.active_pane = $(e.target).attr("href")
        })
    },
    methods: {
        submit(e) {
            let form = $('#marketing_tool_form')
            let btn = $('#tool_setting_submit_btn')

            form.validate( {
                rules: {
                    hor_banner_file: {
                        required: true
                    },
                    ver_banner_file: {
                        required: true
                    },
                }
            })

            if(!form.valid()) {
                return
            }

            KTApp.progress(btn)

            let params = {
                hor_banner: this.marketing_setting.hor_banner,
                ver_banner: this.marketing_setting.ver_banner
            }

            marketingService.uploadBanner(params)
                .then(response => {
                    this.showMsg(form, 'success', response.data.message)
                })
                .catch(({response}) => {
                    if(response.data) {
                        form.validate().showErrors(response.data.data)
                    }
                    this.showMsg(form, 'danger', response.data.message)
                })
                .finally(() => {
                    KTUtil.scrollTop()
                    KTApp.unprogress(btn)
                })

        },
    }
}
</script>

<style>
    @media (min-width: 768px) {
        #tool_setting > div > :first-child {
            border-left: 1px solid #ddd;
        }
    }
</style>